import {Form, InputNumber} from 'antd';
import React from 'react';

import {CustomSelect, getCustomSelectDefaultPreset} from 'components/form/inputs/custom-select';
import {DateCell} from 'components/table/columns/date-cell/date-cell';
import {DATE, DATE_DMY} from 'shared/constants/date-format';

import {MAX_OPERATIONS, MIN_OPERATIONS} from '../../model/constants';
import s from './table-parameters-filter.module.less';

interface ITableParametersFilterProps {
    isFilterApplied?: boolean;
}

export const TableParametersFilter = (
    {isFilterApplied}: ITableParametersFilterProps,
) => (
    <div className={s.filters}>
        <Form.Item
            label="Статус документа"
            name="statusCode"
            className={s.filters__item}
        >
            <CustomSelect
                fixedDropdown={false}
                settings={{
                    ...getCustomSelectDefaultPreset(
                        '/lookupValue/SUMMARY_TRANSACTIONS_PROTOCOL_INTERFACE_STATUS',
                    ),
                    placeholder: 'Выберите статус документа',
                    isClearable: true,
                    isDisabled: isFilterApplied,
                }}
            />
        </Form.Item>

        <Form.Item
            label="Дата начала отчетного периода"
            name="startPeriodDate"
            data-type="date"
            className={s.filters__item}

        >
            <DateCell
                disabled={isFilterApplied}
                requestFormat={DATE}
                format={DATE_DMY}
            />
        </Form.Item>

        <Form.Item
            label="Дата окончания отчетного периода"
            name="endPeriodDate"
            data-type="date"
            className={s.filters__item}

        >
            <DateCell
                disabled={isFilterApplied}
                requestFormat={DATE}
                format={DATE_DMY}
            />
        </Form.Item>

        <Form.Item
            label="Общее количество операций"
            name="totalTransactionsAmt"
            className={s.filters__item}

        >
            <InputNumber
                placeholder="Введите общее количество операций"
                disabled={isFilterApplied}
                min={MIN_OPERATIONS}
                max={MAX_OPERATIONS}
            />
        </Form.Item>

        <Form.Item
            label="Количество операций с наличием первичных учетных документов"
            name="transactionsWithDocs"
            className={s.filters__item}

        >
            <InputNumber
                placeholder="Введите количество операций с наличием первичных учетных документов"
                disabled={isFilterApplied}
                min={MIN_OPERATIONS}
                max={MAX_OPERATIONS}
            />
        </Form.Item>
    </div>
);
